<template>
  <a-drawer
    title="字典列表"
    @close="onClose"
    :visible="visible"
    width="1000px"
  >
    <a-card :bordered="false" class="content">
      <div class="table-operator">
        <a-button type="primary" icon="plus" @click="$refs.dictItemAddOrUpdate.init('','add',queryParam.dictId)" v-action="'sys:dict:item:save'">新建</a-button>
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作 <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>
      <s-table
        bordered
        ref="table"
        :columns="columns"
        :alert="alert"
        :data="loadData"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :rowKey="record => record.id"
      >
        <span slot="action" slot-scope="text, record">
          <span v-action="'sys:dict:item:update'">
            <a @lick="edit(record)">修改</a>
            <a-divider type="vertical" />
          </span>
          <span v-action="'sys:dict:item:del'">
            <a-popconfirm title="是否删除字典" @confirm="del(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;" style="color: red">删除</a>
            </a-popconfirm>
          </span>
        </span>
      </s-table>
      <dict-item-add-or-update
        ref="dictItemAddOrUpdate"
        @ok="queryPage"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { dictItemList, delItemObj } from '@api/sys/dict'
import DictItemAddOrUpdate from './dictItemAddOrUpdate'
import { TableMixin } from '@/mixins/TableMixin'
export default {
  name: 'DictItemDrawer',
  mixins: [TableMixin],
  components: {
    DictItemAddOrUpdate
  },
  data () {
    return {
      visible: false,
      loading: false,
      columns: [
        {
          title: '#',
          width: '10%',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '名称',
          dataIndex: 'itemText'
        },
        {
          title: '代码',
          dataIndex: 'itemCode'
        },
        {
          title: '类型',
          dataIndex: 'type'
        }, {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ],
      tableData: [],
      queryParam: {
        dictId: '',
        name: '',
        type: ''
      },
      loadData: parameter => {
        return dictItemList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      }
    }
  },
  methods: {
    init (record) {
      this.visible = true
      this.queryParam.dictId = record.id
      this.queryPage()
    },
    edit (record) {
      this.$refs.dictItemAddOrUpdate.edit(record.id, 'edit', this.queryParam.dictId)
    },
    del (record) {
      delItemObj(record.id).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    onClose () {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
